import { API_URL } from "../../../../constants";
import { SaasConnectionUrlDomain } from "../../../../dashboard/saas/types";
import * as httpNetworking from "../../../../httpNetworking";

const VERSION = 1;
const URL = API_URL + "/saas/multi-tenancy/connection-uri-domain";

export async function getMultitenancyAppInfo(data: {
    deploymentType?: "development" | "production";
    deploymentId?: string;
}): Promise<SaasConnectionUrlDomain> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 60000,
        params: data
    };

    const response = await httpNetworking.simpleGETRequest(URL, options, VERSION);

    return response.data as SaasConnectionUrlDomain;
}
